import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ApplicationUIContext, DrawerContent } from '@yuhuinc/ui-library';
import { Radio, Alert } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import SelectIncentive from './SelectIncentive';
import CreateIncentive from './CreateIncentive';

const RADIO_GROUP_OPTIONS = [
  {
    value: 'select',
    label: getTranslatedString(
      'landlordPortal.applicationManagement.inviteLeadToApply.additionalInformation.rentalIncentives.selectIncentive'
    ),
  },
  {
    value: 'create',
    label: getTranslatedString(
      'landlordPortal.applicationManagement.inviteLeadToApply.additionalInformation.rentalIncentives.createIncentive'
    ),
  },
];

const StyledAlert = styled(Alert)`
  .ant-alert-message {
    font-size: ${({ isMobile }) => (isMobile ? '20px' : '16px')};
  }

  .ant-alert-description {
    font-size: ${({ isMobile }) => (isMobile ? '16px' : '14px')};
  }

  .ant-alert-description p {
    margin-bottom: 8px;
  }

  .ant-alert-description .ant-btn.ant-btn-link {
    padding: 0;
  }
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  width: 100%;

  > * {
    flex: 1;
    text-align: center;
  }
`;

const NewIncentiveErrorAlert = ({ message, description, isMobile }) => {
  return (
    <StyledAlert
      message={message}
      description={description}
      type="error"
      showIcon
      isMobile={isMobile}
    />
  );
};

const AddIncentive = ({ selectedUnit, onAdd, closeDrawer }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [addRentalIncentiveOption, setAddRentalIncentiveOption] = useState('select');
  const [newIncentiveError, setNewIncentiveError] = useState(false);

  function onAddRentalIncentiveOptionChange({ target: { value } }) {
    setAddRentalIncentiveOption(value);
  }

  function onSelectFoundIncentive(selectedIncentive) {
    onAdd(selectedIncentive);
    closeDrawer();
  }

  function onSubmitNewIncentive(newIncentive) {
    onAdd(newIncentive);
    closeDrawer();
  }

  return (
    <DrawerContent>
      {newIncentiveError && <NewIncentiveErrorAlert {...newIncentiveError} isMobile={isMobile} />}
      <StyledRadioGroup
        value={addRentalIncentiveOption}
        onChange={onAddRentalIncentiveOptionChange}
        optionType="button"
        size={isMobile && 'large'}
        options={RADIO_GROUP_OPTIONS}
      />
      {addRentalIncentiveOption === 'select' && (
        <SelectIncentive
          selectedUnit={selectedUnit}
          onCancel={closeDrawer}
          onSelect={onSelectFoundIncentive}
        />
      )}
      {addRentalIncentiveOption === 'create' && (
        <CreateIncentive
          onSubmit={onSubmitNewIncentive}
          onCancel={closeDrawer}
          onError={setNewIncentiveError}
        />
      )}
    </DrawerContent>
  );
};

NewIncentiveErrorAlert.propTypes = {
  message: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isMobile: PropTypes.bool,
};

AddIncentive.propTypes = {
  selectedUnit: PropTypes.object,
  onAdd: PropTypes.func,
  closeDrawer: PropTypes.func,
};

export default AddIncentive;
